import { createSelector } from 'reselect'

const authToken = (state) => state.getIn(['authToken', 'token'])

export const selectAuthToken = createSelector([authToken], (authToken) => authToken)
